import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Button, Icon, Input, Divider} from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextAreaField from '../formFields/TextAreaField';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: 'add',
            formLayout: 'horizontal',
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        if(this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
            this.props.setUserId(id)
        }
    }

    render() {
        let _self = this;
        const {formLayout} = this.state;
        let fullName;

        if (this.props.initialValues) {
            fullName = this.props.initialValues.name + ' ' + this.props.initialValues.family
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">نطرات درباره {fullName}</Divider>
                </Row>
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <Field
                                name="customer_review"
                                component={TextAreaField}
                                label="متن نظر"
                                rows="20"
                                placeholder="متن نظر"
                            />
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                ایجاد
                            </RTLButton>
                            <RTLButton href="#/user/list"  className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default AddEditForm = reduxForm({
    form: 'addsettle',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AddEditForm)
